import { render, staticRenderFns } from "./MySpaceArticles.vue?vue&type=template&id=e7143d72&"
import script from "./MySpaceArticles.vue?vue&type=script&lang=js&"
export * from "./MySpaceArticles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports